<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
        <v-layout v-show="!cxt.isFilterMode()" style="overflow:hidden" justify-end>
        </v-layout>
        <v-flex sm4 xs4 v-if="cxt.isFilterMode()">
          <v-text-field
            autofocus
            label="Фильтр"
            v-show="cxt.isFilterMode()"
            v-model="cxt.filterString"
            solo flat
          ></v-text-field>
        </v-flex>
        <span v-show="!cxt.isSelectMode()">
          <span v-show="!cxt.isFilterMode()"> 
            <v-btn  icon @click="addItem()">
              <v-icon>add</v-icon>
            </v-btn>
          </span>
        </span>
        <v-ops-btn :cxt="cxt" flat></v-ops-btn>  
      </v-toolbar>
      <v-card-scroll ref="cardScroll">
        <v-container px-2 pt-2
          fluid
          grid-list-lg
          style="min-height: 0; margin-top: 0"
        >
          <v-layout row wrap >
              <template v-for="item in filteredItems">
            <v-flex xs12>
              <v-card  :to="'/chats/' + item.id">
                <v-card-title>
                  <v-layout row>
                    <div> 
                    <v-badge v-show="item.lastCount > 0" right>
                      <span slot="badge">{{item.lastCount}}</span>
                      <span>{{getItemTitle(item)}}</span>
                    </v-badge>  
                      <span v-show="item.lastCount === 0">{{getItemTitle(item)}}</span>                  
                    </div>
                    <v-spacer></v-spacer>
                    <div>{{getItemLastTime(item)}}</div>
                  </v-layout>                
                </v-card-title>
                <v-card-text>
                  <div v-html="getItemHTML(item)">
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
              </template>
          </v-layout>
        </v-container>
      </v-card-scroll>  
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import classes from '../../api/classes'
  import vOpsBtn from '../common/OpsBtn'
  import vChatForm from './ChatForm.vue'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'chat-list',
    components: {vOpsBtn, vCardScroll},
    data: () => ({
      cxt: null,
      timer: ''
    }),
    mounted () {
      this.fetchData()
    },
    props: {
      itemId: {
        type: String,
        default: null
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal === 'root') {
          this.fetchData()
        }
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        if (newVal && (this.itemId === 'root')) {
          this.fetchData()
        }
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => item.uid)
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      cxt.actions.push(new classes.Action(this, 'Все', null,
        () => {
          this.cxt.showAll()
        }))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Новый обсуждение', null,
        () => this.addItem()))

      cxt.title = 'Сообщения'
      cxt.titleIcon = 'chat'
      cxt.selectTitle = 'Выбор диалогов'
      cxt.filterMode = true
      this.cxt = cxt
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        chatterChats: 'getChatterChats',
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      orderedItems () {
        var result = this.chatterChats.slice()
        return result.sort((a, b) => {
          if (a.lastCount > 0 && b.lastCount > 0) {
            return b.last.published - a.last.published
          }
          if (a.lastCount === 0 && b.lastCount === 0) {
            return b.last.published - a.last.published
          }
          return b.lastCount - a.lastCount
        })
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              this.getItemTitle(item),
              this.getItemHTML(item),
              this.getItemLastTime(item))
        }

        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      },
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.orderedItems ? label + this.cxt.selectedCount() + ' из ' + this.orderedItems.length + '' : ''
        } else {
          return this.orderedItems ? label + this.filteredItems.length + ' из ' + this.orderedItems.length + '' : ''
        }
      }
    },
    methods: {
      fetchData () {
        if (this.getProfileHaveClient) {
          this.$store.dispatch('fetchChatterChats')
        }
      },
      chatClick (value) {
        this.$router.push({name: 'Chat'})
      },
      openItem (id) {
        this.dialogOpen(id)
      },
      addItem () {
        this.openItem(null)
      },
      getItemTitle (item) {
        return item.name ? item.partnerName + ': ' + item.name : item.partnerName
      },
      getItemHTML (item) {
        var result = item.last.clientName ? item.last.clientName : ''
        result = result + (item.last.text ? ': ' + item.last.text : '')
        return result
      },
      getItemLastTime (item) {
        var result = item.last.published ? formats.formatDateTime(item.last.published) : ''
        return result
      },
      dialogOpen (id) {
        dialogs.register('v-chat-form', vChatForm)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-chat-form toolbar :itemId="dialogItemId"  v-on:close="$emit('close')"
          :fullscreen="fullscreen"></v-chat-form>
          `,
          data () {
            return {
              dialogItemId: id,
              fullscreen: fullscreen
            }
          }
        }
        dialogs.modal(comp)
      }

    }
  }
</script>  



// WEBPACK FOOTER //
// ChatList.vue?486d6d4e